/* eslint-disable prettier/prettier */
import { PATHS } from 'config/routes'
import { getAllGameQuery, getPageInfoQuery } from 'dataLayer/game'
import { memo, useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import {
	StackedCarousel,
	ResponsiveContainer,
} from 'react-stacked-center-carousel'
import { randomIntFromInterval } from 'utils/helpers'
import { useMediaQuery, mediaQueryPoint } from 'utils/hooks'
import defaultSlider from 'assets/images/demo-slider.svg'
import { makeData } from 'utils/makeData'

function HomeSliderMobile({ isCreateRoom, isFriendPage }) {
	const navigate = useNavigate()

	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.sm}px)`)
	const isMobileXs = useMediaQuery(`(max-width: ${mediaQueryPoint.xs}px)`)

	const { data: games, isLoading } = useQuery(getPageInfoQuery())
	const gamesDefault = makeData('game', 2)
	const [listBanner, setListBanner] = useState([])
	useEffect(() => {
		if (games && games.length > 0) {
			const newList = games.filter(it => it.device === 2)
			if (newList.length > 0) {
				if (newList.length > 1) {
					setListBanner(newList)
				} else {
					setListBanner([...newList, newList[0]])
				}
			} else {
				setListBanner(gamesDefault)
			}
		} else {
			setListBanner(gamesDefault)
		}
	}, [games])
	const [gameSelect, setGameSelect] = useState(null);
	function handleGameSelect(game) {
		setGameSelect(game)
	}
	const handleSelect = (dataSelect) => {
		console.log(dataSelect);

		let type = dataSelect?.type?.toLowerCase()
		if (type === "href" && dataSelect.link && dataSelect.link.length > 1) {
			navigate(dataSelect.link)
		}
	}

	const ref = useRef(<StackedCarousel></StackedCarousel>)
	const Slide = memo(props => {
		if (listBanner && listBanner?.length > 0) {
			const { data, dataIndex } = props
			const { image, description } = data[dataIndex]
			// TODO: onClick image still work on image with lower z-index
			return isFriendPage ?
				<img draggable={false} src={data[dataIndex].image || defaultSlider} onError={e => {
					e.target.onerror = null
					e.target.src = defaultSlider
				}}
					// 		onClick={() => handleGameSelect()}
					alt={description} />

				: (
					<div onClick={() => handleSelect(data[dataIndex])}>
						<img draggable={false}
							src={image || defaultSlider}
							onError={e => {
								e.target.onerror = null
								e.target.src = defaultSlider
							}}

							alt={description} />
					</div>

				)
		}
	})

	useEffect(() => {
		const interval = setInterval(() => {
			if (ref && ref.current && !isFriendPage) {
				ref.current.goNext();
			}
		}, 5000);

		return () => clearInterval(interval);
	}, [])

	// TODO: slider dot

	return (
		<ResponsiveContainer
			carouselRef={ref}
			render={(parentWidth, carouselRef) => {
				let currentVisibleSlide = 3
				return (
					<StackedCarousel
						className="mobile-slider"
						ref={carouselRef}
						data={!isLoading ? listBanner : gamesDefault}
						carouselWidth={parentWidth}
						slideWidth={isMobileXs ? 300 : isMobile ? 350 : 450}
						fadeDistance={isMobile ? 0 : 0.3}
						slideComponent={Slide}
						maxVisibleSlide={currentVisibleSlide}
						currentVisibleSlide={currentVisibleSlide}
						useGrabCursor
					/>
				)
			}}
		/>
	)
}

export default HomeSliderMobile
